import React from "react"
import CardButton from "../button"
import * as styles from "./media.module.scss"

const Media = ({ children, caption }) => {
  return (
    <div className={styles.media}>
      <CardButton disabled className={styles.card}>
        {children}
      </CardButton>
      <p>{caption}</p>
    </div>
  )
}

export default Media
